export enum ShipmentFilterLayout {
  Basic = 'BASIC',
  Nested = 'NESTED'
}
